import { useCallback, type FC } from "react";
import { useNavigate } from "react-router-dom";
import { CAMPAIGN_ANALYTICS_ROUTE } from "../CampaignSetup/CampaignSetupConstants";
import ExitCampaignGuard, { exitWithoutConfirm } from "./ExitCampaignGuard";
import SaveDraftModal from "./SaveDraftModal";

interface CampaignDraftDialogsProps {
  guardActive: boolean;
  isDraftOpen: boolean;
  isSaving: boolean;
  onCloseDraft: () => void;
  onSaveDraft: () => Promise<boolean>;
}

/** The exit confirmation and the "save as draft" popup shared by every campaign wizard. */
const CampaignDraftDialogs: FC<CampaignDraftDialogsProps> = ({
  guardActive,
  isDraftOpen,
  isSaving,
  onCloseDraft,
  onSaveDraft,
}) => {
  const navigate = useNavigate();

  const handleSaveAndExit = useCallback(async () => {
    if (await onSaveDraft()) {
      exitWithoutConfirm(() => navigate(CAMPAIGN_ANALYTICS_ROUTE));
    }
  }, [navigate, onSaveDraft]);

  return (
    <>
      <ExitCampaignGuard active={guardActive} onSaveDraft={onSaveDraft} />
      <SaveDraftModal
        open={isDraftOpen}
        isSaving={isSaving}
        onKeepEditing={onCloseDraft}
        onSaveAndExit={handleSaveAndExit}
      />
    </>
  );
};

export default CampaignDraftDialogs;
